import dynamic from 'next/dynamic'
import { useBreakpoint } from '~/hooks'
import { ETH, USDT } from '~/constants/tokens'
const SwapPriceChart = dynamic(
  () => import('~/components/charts/SwapPriceChart'),
  {
    ssr: false,
  },
)

const Chart = () => {
  const { isMobile } = useBreakpoint()

  return isMobile ? null : (
    <SwapPriceChart
      inputToken={ETH}
      outputToken={USDT}
      style={{ margin: '0' }}
    />
  )
}

export default Chart
